import React, { useState } from "react";
import { usePost } from "seed/api";
import swal from "sweetalert";
import l from "components/util/l";
import { useAuth } from "components/util/helpers/providers/AuthProvider";
import View from "components/presentation/start/Start.view";

function Start({
  currentFlow,
  closeStart,
  onChangeFlow
}) {

  const user = useAuth();
  const isDeveloper = user?.isDeveloper;

  const [selectedFolder, setSelectedFolder] = useState(null);

  const [callSave] = usePost("/flows/create_flow", {
    onCompleted: (createdFlow) => {
      window.location.replace(`/app/?flow_id=${createdFlow.id}`)
    }, onError: (error) => {
      if (error.status == 400)
        return swal(l("Has llegado a tu límite de soluciones%VG104"), l("Actualiza tu plan%VG105"), "error");
      swal(l("Error al crear solución%SB001"), l("Por favor cierra sesión y vuelve a entrar%SB035"), "error")
    }
  });

  const onClickCreateFlow = () => {
    callSave({
      name: l("Nueva solución%GA104"),
      version_name: l("Versión inicial%SA268"),
      description: "",
      settings: {}
    });
  }

  return (
    <View
      user={user}
      currentFlow={currentFlow}
      selectedFolder={selectedFolder}
      isDeveloper={isDeveloper}
      setSelectedFolder={setSelectedFolder}
      closeStart={closeStart}
      onClickCreateFlow={onClickCreateFlow}
      onChangeFlow={onChangeFlow} />
  );
}

export default Start;